module.exports = __webpack_public_path__ + "static/img/active1.3184c07b.png";